import styled from 'styled-components';
import Image from 'next/image';

export const BannerContainer = styled.div`
  width: 100%;
  height: 402px;
`;

export const Banner = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: fill;
  aspect-ratio: 16/9;
  position: relative !important;
  @media only screen and (max-width: 1380px) and (min-width: 1200px) {
    object-fit: scale-down;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    object-fit: fill;
  }
`;

export const Container = styled.div`
  max-width: 1340px;
  margin: 20px auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 0 12px;
  }
`;

export const TopFAQItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 33px;
`;

export const TopFAQItem = styled.div`
  & .greek-islands-makrdown a {
    text-decoration: underline;
  }
`;

export const DecriptionItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const DecriptionItemContainer = styled.div`
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const DescriptionTextContainer = styled.div`
  text-align: center;
`;

export const BannerContainerMobile = styled.div`
  width: 100%;
  height: 150px;
`;

export const ContainerMobile = styled.div`
  margin: 20px auto;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const MobileTopFAQContainer = styled.div`
  display: flex;
  padding: 0px 12px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`;

export const MobileDescriptionItemContainer = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
